import { jwtDecode } from 'jwt-decode';
import { setAuthToken } from '../services/api';

// Store auth data
export const setAuth = (token, userData) => {
  try {
    if (token) {
      localStorage.setItem('token', token);
      setAuthToken(token);

      if (userData) {
        localStorage.setItem('user', JSON.stringify(userData));
      }

      window.dispatchEvent(new CustomEvent('authChange', {
        detail: { type: 'login', userData }
      }));

      return true;
    }
    return false;
  } catch (error) {
    console.error('Error setting auth data:', error);
    return false;
  }
};

// Get auth state
export const getAuth = () => {
  try {
    const token = localStorage.getItem('token');

    let userRole = null;

    if (token) {
      try {
        const decoded = jwtDecode(token);
        userRole = decoded.role || null;

        // Check if token is expired
        const currentTime = Date.now() / 1000;
        if (decoded.exp && decoded.exp < currentTime) {
          clearAuth();
          return { isAuthenticated: false, userRole: null };
        }
      } catch (decodeError) {
        // Token may be in a non-JWT format
      }
    }

    let userData = null;
    const userDataString = localStorage.getItem('user');
    if (userDataString) {
      try {
        userData = JSON.parse(userDataString);
      } catch (error) {
        // Corrupted data
      }
    }

    return {
      isAuthenticated: !!token,
      userRole: userRole || (userData?.role || null),
      userData
    };
  } catch (error) {
    return { isAuthenticated: false, userRole: null, userData: null };
  }
};

// Clear auth data
export const clearAuth = () => {
  try {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setAuthToken(null);
    return true;
  } catch (error) {
    return false;
  }
};

// Redirect to login with a safe return URL (relative paths only, no open redirects)
export const redirectToLogin = (returnUrl = window.location.pathname) => {
  // Only allow relative paths to prevent open redirect attacks
  const safeUrl = (returnUrl && returnUrl.startsWith('/') && !returnUrl.startsWith('//'))
    ? returnUrl
    : '/';
  const encodedReturnUrl = encodeURIComponent(safeUrl);
  window.location.href = `/login?returnUrl=${encodedReturnUrl}`;
};

// Get the appropriate dashboard URL based on user role
export const getDashboardUrl = (role) => {
  switch (role) {
    case 'system_admin':
    case 'manager':
    case 'warehouse':
    case 'accounting':
    case 'admin':
      return '/admin';
    case 'customer_admin':
    case 'regular_user':
    case 'customer':
      return '/customer';
    default:
      return '/auth-error';
  }
};

// Redirect based on user role
export const redirectByRole = (role, navigate = null) => {
  const url = getDashboardUrl(role);

  if (navigate) {
    navigate(url, { replace: true });
  } else {
    window.location.href = url;
  }
};
